import styled, { css } from 'styled-components'

import { color, spacing, typography } from '../../themes'

export const Container = styled.div`
  position: relative;
`

interface TextContainerProps {
  isExpanded: boolean
  height: string
  truncateLines: number
}

export const TextContainer = styled.div<TextContainerProps>`
  overflow: hidden;
  transition: height 0.2s ease-in-out;
  ${typography('body1')};

  ${({ isExpanded, height, truncateLines }) =>
    isExpanded
      ? css`
          height: ${height};
        `
      : css`
          height: ${height};
          display: -webkit-box;
          -webkit-line-clamp: ${truncateLines};
          -webkit-box-orient: vertical;
        `}
`

interface MoreButtonContainerProps {
  show: boolean
  fixedPosition: boolean
}

export const MoreButtonContainer = styled.div<MoreButtonContainerProps>`
  display: flex;
  justify-content: flex-end;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  width: 100%;
  margin-top: ${spacing(2)};

  ${({ fixedPosition }) =>
    fixedPosition &&
    css`
      position: absolute;
      bottom: calc(-${spacing(2)} + -26px);
    `}
`

export const MoreButton = styled.button`
  ${typography('body1')};
  color: ${color('gray.02')};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  text-underline-position: under;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.5;
  }
`
